module.exports = __webpack_public_path__ + "img/team_title.31cd9596.png";